<template>
  <div id='diagram-buton' class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item :click="notices" eventType='addDevice' v-if="addDeviceBtn" :tooltipText='$t("Topo.devAdd")' prefixIcon='icon hero-icon hero-icon-add'></e-item>
        <e-item :click="notices" eventType='delDevice' v-if="delDeviceBtn" :tooltipText='$t("Topo.delDev")' prefixIcon='icon hero-icon hero-icon-remove'></e-item>
        <e-item :click="notices" eventType='upGrade' v-if="upGradeBtn" :tooltipText='$t("Software.updataOper")' prefixIcon='icon hero-icon hero-icon-upload'></e-item>
        <e-item :click="notices" eventType='downGrade' v-if="downGradeBtn" :tooltipText='$t("Software.rollback")' prefixIcon='icon hero-icon hero-icon-download'></e-item>
        <e-item :click="notices" eventType='synVersion' v-if="synVersionBtn" :tooltipText='$t("同步版本")' prefixIcon='icon hero-icon hero-icon-synchronize'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>

  export default {
    name: 'BSButton',
    props: {
      addDeviceBtn: { type: Boolean, default: false },
      delDeviceBtn: { type: Boolean, default: false },
      upGradeBtn: { type: Boolean, default: false },
      downGradeBtn: { type: Boolean, default: false },
      synVersionBtn: { type: Boolean, default: false },
    },
    data(){
      return{

      }
    },
    methods: {
      notices(args) {
        this.$emit('notice', args.item.eventType);
      },
    }
  }
</script>

